
import { Button, Modal, Table } from 'antd'
import React from 'react'
import {mapAccountingRecordDataRange, ReceivablesType} from '../../../axios/dictionaries'
import { CustomCol, CustomRow } from '../../../components/Custom'
import DetailTitle from '../../../components/DetailTitle'
import { apiAccountingRecordCompilationExport, fetchAccountingRecordCompilationDetails } from '../../../services/accountingRecord'
import {findDict, formatTime, handleExportParams, moneyAddComma, ToParamForObject} from '../../../utils'
import moment from "moment";

/**
 * @Author: zhao - 🍉
 * @Date: 2021-12-20 17:27:40
 * @LastEditTime: 2021-12-21 10:34:19
 * @LastEditors: zhao - 🍉
 * @Description: 租金汇集明细
 * @FilePath: /zhzj-admin/src/page/AccountingRecord/components/CompilationView.jsx
 */
class CompilationView extends React.Component{
    constructor() {
        super()
        this.state = {
            compilationData: {},
            childTableData: null
        }
    }
    componentDidMount() {
        this.postAccountingRecordCompilationDetails()
    }

    postAccountingRecordCompilationDetails() {
        const data = { accountingRecordLogId: this.props.accountingRecordLogId }
        fetchAccountingRecordCompilationDetails(data).then(res => {
            this.setState({ compilationData: res })
        })
    }
    render(){
        const { labelWidth } = this.props
        const { compilationData = {} } = this.state

        const setChildTableData = (data) => {
            this.setState({ childTableData: data })
        }

        // const mapReceiveStatus = [
        //     { title: '待审核', value: 1 },
        //     { title: '未结清', value: 2 },
        //     { title: '已结清', value: 3 },
        //     { title: '已退不收', value: 4 },
        // ]

        const renderFooter = () => {
            return <Button onClick={() => setChildTableData(null)}>关闭</Button>
        }

        
        const monthlyBillColumns = [
            { title: '应收日期', dataIndex: 'mustPayDate', width: 100, render: (text) => {
                    return formatTime(text, 'YYYY-MM-DD')
                }},
            // { title: '商户简称', dataIndex: 'shortName', width:100 },
            // { title: '项目名称', dataIndex: 'projectName', width: 170 },
            { title: '房源', dataIndex: 'buildingName', width: 220,render(text, record, index) {
                    return <span>
                <div>{record.roomNo ? record.roomNo : ''}</div>
                <div>{record.buildingName ? record.buildingName : ''}</div>
            </span>
                } },
            { title: '租客', dataIndex: 'customerName', width: 120,render(text, record, index) {
                    return <span>
                <div>{record.customerName ? record.customerName : ""}</div>
                <div>{record.phone ? record.phone : ""}</div>
            </span>
                } },
            { title: '账单名称', dataIndex: 'feeName', width: 100 },
            {
                title: '账单周期',
                dataIndex: 'billBeginDate',
                width: 120,
                render(text, record, index) {
                    return <span >
                <div>{record.billBeginDate ? moment(record.billBeginDate).format('YYYY-MM-DD') : null}</div>
                <div>{record.billEndDate ? moment(record.billEndDate).format('YYYY-MM-DD') : null}</div>
            </span>
                }
            },
            {
                title: '应收 | 已收（元）',
                dataIndex: 'receivedMoney',
                width: 120,
                render(text, record, index) {
                    return <span>
                <div>{moneyAddComma(record.billMoney)}</div>
                        {record.receivedMoney ? <div style={{ color: "red" }}>{moneyAddComma(record.receivedMoney)}</div> : null}
            </span>
                }
            },
            { title: '手续费', dataIndex: 'poundageMoney', width: 100 },
            { title: '结余金额', dataIndex: 'balanceMoney', width: 100 },
            {
                title: '账单状态 | 结清日期',
                dataIndex: 'receiveStatus',
                width: 120,
                render(text, record, index) {
                    let now = ReceivablesType.find(item => item.value === text);
                    if (now)
                        return <span >
                    <div>{record.historyBill ? "历史迁移" : now.title}</div>
                    <div>{record.finishDate ? moment(record.finishDate).format('YYYY-MM-DD') : null}</div>
                </span>
                    return null
                }
            },
        ]
        const overdueMonthColumns = [
            { title: '应收日期', dataIndex: 'overdueMonth' },
            { title: '应收金额', dataIndex: 'overdueReceivableMoney' },
            { title: '已收金额', dataIndex: 'overdueReceivedMoney' },
            { title: '手续费', dataIndex: 'overduePoundageMoney' },
            { title: '结余金额', dataIndex: 'overdueBalanceMoney' },
            { title: '账单明细', dataIndex: 'overdueBillList', render: (text) => {
                // eslint-disable-next-line no-script-url
                return <a href="javascript:;" onClick={() => setChildTableData(text)}>查看</a>
            } },
        ]
        const prepayMonthColumns = [

            { title: '应收月份', dataIndex: 'prepayMonth' },
            { title: '应收金额', dataIndex: 'prepayReceivableMoney' },
            { title: '已收金额', dataIndex: 'prepayReceivedMoney' },
            { title: '手续费金额', dataIndex: 'prepayPoundageMoney' },
            { title: '结余金额', dataIndex: 'prepayBalanceMoney' },
            { title: '账单明细', dataIndex: 'prepayBillList', render: (text) => {
                // eslint-disable-next-line no-script-url
                return <a href="javascript:;" onClick={() => setChildTableData(text)}>查看</a>
            } },
        ]

        const exportParmas = ToParamForObject({ 
            accountingRecordLogId: this.props.accountingRecordLogId,
            ...handleExportParams()
        })
        const exportUrl = apiAccountingRecordCompilationExport + '?' + exportParmas
        return (
            <div>
                <Button  type="primary" icon="export" href={exportUrl} style={{position: 'absolute', right: 0, top: 50}}>
                    导出
                </Button>
                <DetailTitle title="基础信息" />
                <CustomRow >
                    <CustomCol labelStyle={{ width: labelWidth }} colStyle={{ paddingLeft: 5 }}  label="商户名称">
                        {compilationData.merchantName}
                    </CustomCol>
                    <CustomCol labelStyle={{ width: labelWidth }} colStyle={{ paddingLeft: 5 }}  label="数据范围">
                        {findDict(mapAccountingRecordDataRange,compilationData.dataRange).title}
                    </CustomCol>
                    <CustomCol labelStyle={{ width: labelWidth }} colStyle={{ paddingLeft: 5 }}  label="楼栋">
                        {compilationData.buildingNames}
                    </CustomCol>
                </CustomRow>
                <CustomRow divider>
                    
                    <CustomCol labelStyle={{ width: labelWidth }} colStyle={{ paddingLeft: 5 }}  label="开始日期">
                        {compilationData.startDate}
                    </CustomCol>
                    <CustomCol labelStyle={{ width: labelWidth }} colStyle={{ paddingLeft: 5 }}  label="结束日期">
                        {compilationData.endDate}
                    </CustomCol>
                    <CustomCol labelStyle={{ width: labelWidth }} colStyle={{ paddingLeft: 5 }}  label="所属月份">
                        {compilationData.month}
                    </CustomCol>
                </CustomRow>

                <CustomRow divider>
                    <CustomCol labelStyle={{ width: labelWidth }} colStyle={{ paddingLeft: 5 }}  label="应收总金额">
                        {compilationData.receivableTotalMoney}
                    </CustomCol>
                    <CustomCol labelStyle={{ width: labelWidth }} colStyle={{ paddingLeft: 5 }}  label="已收总金额">
                        {compilationData.receivedTotalMoney}
                    </CustomCol>
                    <CustomCol labelStyle={{ width: labelWidth }} colStyle={{ paddingLeft: 5 }}  label="手续费总金额">
                        {compilationData.poundageTotalMoney}
                    </CustomCol>

                </CustomRow>
                <CustomRow divider>
                    <CustomCol labelStyle={{ width: labelWidth }} colStyle={{ paddingLeft: 5 }}  label="结余总金额">
                        {compilationData.balanceTotalMoney}
                    </CustomCol>
                    <CustomCol labelStyle={{ width: labelWidth }} colStyle={{ paddingLeft: 5 }}  label="手续费费率">
                        {compilationData.serviceCharge}
                    </CustomCol>
                    <CustomCol labelStyle={{ width: labelWidth }} colStyle={{ paddingLeft: 5 }}  label="汇集期数">
                        {compilationData.collectionPeriod}
                    </CustomCol>
                </CustomRow>

                <DetailTitle title="当月账单" />
                <CustomRow divider>
                    <CustomCol labelStyle={{ width: labelWidth }} colStyle={{ paddingLeft: 5 }}  label="应收金额">
                        {compilationData.monthlyReceivableMoney}
                    </CustomCol>
                    <CustomCol labelStyle={{ width: labelWidth }} colStyle={{ paddingLeft: 5 }}  label="已收金额">
                        {compilationData.monthlyReceivedMoney}
                    </CustomCol>
                    <CustomCol labelStyle={{ width: labelWidth }} colStyle={{ paddingLeft: 5 }}  label="手续费">
                        {compilationData.monthlyPoundageMoney}
                    </CustomCol>

                </CustomRow>
                <CustomRow divider>
                    <CustomCol labelStyle={{ width: labelWidth }} colStyle={{ paddingLeft: 5 }}  label="结余金额">
                        {compilationData.monthlyBalanceMoney}
                    </CustomCol>
                </CustomRow>
                <Table 
                    columns={monthlyBillColumns}
                    dataSource={compilationData.monthlyBillList || []}
                    scroll={{x: 900}}
                />
                <DetailTitle title="逾期月份数据" />
                <Table 
                    columns={overdueMonthColumns}
                    dataSource={compilationData.overdueMonthList || []}
                    scroll={{x: 900}}
                />
                <DetailTitle title="预交月份数据" />
                <Table 
                    columns={prepayMonthColumns}
                    dataSource={compilationData.prepayMonthList || []}
                    scroll={{x: 900}}
                />

                <Modal title="明细数据" visible={!!this.state.childTableData} width={1000} footer={renderFooter()} onCancel={() => setChildTableData(null)}>
                    <div style={{padding: 20}}>
                        <Table 
                            columns={monthlyBillColumns}
                            dataSource={this.state.childTableData || []}
                            scroll={{x: 900}}
                        />
                    </div>
                </Modal>
            </div>
        )
    }
}

export default CompilationView


// WEBPACK FOOTER //
// ./src/page/AccountingRecord/components/CompilationView.jsx